export default __webpack_public_path__ + "static/media/portfolio-hover.6193290f.svg";